import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';


/**
 * This is a hack whos purpose is to send a message to a child iframe just prior to onDestroy of the iframe component.
 */
@Injectable({
  providedIn: 'root'
})
export class IframeSpaLogoutGuard  {
  component: Object;
  
  canDeactivate(component: any,  route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot ): Promise<boolean> {
    console.log("Sending an CL_UNLOAD to the child iframe");

    var iframes = document.getElementsByTagName('iframe');
    var unloadTimeout = 1;
    if ( route && route.data && route.data.unloadTimeoutValue != undefined )
    {
      unloadTimeout = route.data.unloadTimeoutValue;
    }
    if (iframes && iframes.length > 0) {
      var win = iframes[0].contentWindow;
      console.log("About to send CL_UNLOAD to child with this timeout", unloadTimeout);
      if (win) {
        win.postMessage("CL_UNLOAD", "*");

        return new Promise(resolve => setTimeout(() => {
          resolve(true)
        },
        unloadTimeout)); // needed to let the postMessage happen, variable timeout because some iframes need more time
      }
    }
    return Promise.resolve(true);
  }
  
}